import { SceneCommon, SCENE_COMMON_TOKEN } from '@cgs/common';
import {
  BuyFeaturePopupComponent,
  DrawOrderConstants,
  RESOURCES_COMPONENT_TOKEN,
  ResourcesComponent,
} from '@cgs/machines';
import { Container, SceneObject } from '@cgs/wge';

const DRAW_ORDER = DrawOrderConstants.Top + 1;

export abstract class TrifectaBuyFeaturePopup extends BuyFeaturePopupComponent {
  public readonly scene: SceneObject;

  protected constructor(protected readonly container: Container) {
    super();

    const sceneCommon = container.resolve<SceneCommon>(SCENE_COMMON_TOKEN);
    const scene = sceneCommon.sceneFactory.build('buy_feature/scene')!;

    if (!scene) {
      throw new Error('Scene not found');
    }

    scene.initialize();
    scene.z = DRAW_ORDER;

    const resourceComponent = container.resolve<ResourcesComponent>(RESOURCES_COMPONENT_TOKEN);
    resourceComponent.root.addChild(scene);
    this.scene = scene;
  }
}
